import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { CurrencyExchangeEntity } from "domain/entity/CurrencyExchange/CurrencyExchangeEntity";
import { axiosDeleteData, axiosGetData, axiosPostData, axiosPutData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { CurrencyExchangeRepository } from "./CurrencyExchangeRepo";

/**
 * For template
 * @returns 
 */
export const CurrencyExchangeRepoImpl = (): CurrencyExchangeRepository => {
    const url = '/v1/exchangeRate';

    const getEntities = async() : Promise<CurrencyExchangeEntity[]> => {
        return await axiosGetData(referenceAxiosInstance, url, []).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });
        
    }

    const getEntityByKey = async(key: string): Promise<CurrencyExchangeEntity> => {
        return await axiosGetData(referenceAxiosInstance, `${url}/${key}`, []).then(res => {
            return res.data;
        }).catch(err => {
            return null;
        });
    }

    const createEntity = async(newData: CurrencyExchangeEntity) : Promise<ResponseEntity> => {
        return await axiosPostData(referenceAxiosInstance, `${url}`, newData);
    }

    const updateEntity = async(updatedData: CurrencyExchangeEntity): Promise<ResponseEntity> => {
        return await axiosPutData(referenceAxiosInstance, `${url}`, updatedData);
    }

    const deleteEntity= async(key: string): Promise<ResponseEntity> => {
        return await axiosDeleteData(referenceAxiosInstance, `${url}`, key);
    }

    return {
        getEntities: getEntities,
        getEntityByKey: getEntityByKey,
        createEntity: createEntity,
        updateEntity: updateEntity,
        deleteEntity: deleteEntity,
    }
}